var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.896%",
    y1: "50%",
    x2: "65.659%",
    y2: "-7.527%",
    id: "help_svg__svg-686041614a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.844a.781.781 0 01-1.563 0v-.811c0-.9.593-1.685 1.456-1.944a2.344 2.344 0 001.67-2.244c0-1.259-1.087-2.344-2.344-2.344a2.344 2.344 0 00-2.343 2.344.782.782 0 01-1.563 0 3.908 3.908 0 013.906-3.907c2.12 0 3.906 1.786 3.906 3.907a3.906 3.906 0 01-2.784 3.74.468.468 0 00-.341.448v.811zm-.78 2.03A1.562 1.562 0 1114.967 22a1.562 1.562 0 01.001-3.124zm13.28-3.905c0-7.335-5.945-13.281-13.28-13.281-7.337 0-13.283 5.945-13.283 13.281S7.633 28.25 14.97 28.25s13.28-5.944 13.28-13.28zm1.563 0c0 8.199-6.645 14.844-14.844 14.844-8.198 0-14.845-6.645-14.845-14.844C.124 6.771 6.771.125 14.97.125c8.199 0 14.844 6.646 14.844 14.844z",
    fill: "#00264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.844a.781.781 0 01-1.563 0v-.811c0-.9.593-1.685 1.456-1.944a2.344 2.344 0 001.67-2.244c0-1.259-1.087-2.344-2.344-2.344a2.344 2.344 0 00-2.343 2.344.782.782 0 01-1.563 0 3.908 3.908 0 013.906-3.907c2.12 0 3.906 1.786 3.906 3.907a3.906 3.906 0 01-2.784 3.74.468.468 0 00-.341.448v.811zm-.78 2.03A1.562 1.562 0 1114.967 22a1.562 1.562 0 01.001-3.124zm13.28-3.905c0-7.335-5.945-13.281-13.28-13.281-7.337 0-13.283 5.945-13.283 13.281S7.633 28.25 14.97 28.25s13.28-5.944 13.28-13.28zm1.563 0c0 8.199-6.645 14.844-14.844 14.844-8.198 0-14.845-6.645-14.845-14.844C.124 6.771 6.771.125 14.97.125c8.199 0 14.844 6.646 14.844 14.844z",
    fill: "url(#help_svg__svg-686041614a)",
    opacity: 0
  }))));
}

export default SvgHelp;